import React from 'react';

import { DatePicker, Space } from 'antd/es';
import { Field, FormikProps } from 'formik';
import type { Dayjs } from 'dayjs';

interface CustomDatePickerProps {
	onChange: (value: Dayjs | null, dateString: string | Array<string>) => void;
	placeholder: string;
	initValue: string;
	formikBag: FormikProps<any>;
	name: string;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
	initValue,
	onChange,
	placeholder,
	formikBag,
	name,
}) => {
	const dateFormat = ['MM/DD/YYYY', 'MM-DD-YYYY', 'MM.DD.YYYY'];

	return (
		<Field
			name={name}
		>
			{(field) => {
				return (
					<div
						className={`custom-field custom-date-picker ${
							formikBag.errors[name] && formikBag.touched[name] ? 'error' : ''
						} ${
							typeof formikBag.values[name] === 'number' || formikBag.values[name]?.length ? 'focused' : ''
						}`}
					>
						<Space direction="vertical" size={12}>
							<DatePicker
								placeholder={placeholder}
								format={dateFormat}
								onChange={onChange}
								onBlur={() => field.form.setFieldTouched(name, true)}
							/>
						</Space>
						{formikBag.errors[name] && formikBag.touched[name] ? (
							<div className="custom-input__error">
								{formikBag.errors[name]}
							</div>
						) : null}
						<div className="custom-field__placeholder-top">{placeholder}</div>
					</div>
				);
			}}
		</Field>
	);
};

export default CustomDatePicker;
